import { FormikProps, connect } from "formik";

const withFormWrapper = <TFormValues, TExtraProps = {}>(
    WrappedComponent: React.ComponentType<TExtraProps & {
      formik: FormikProps<TFormValues>;
    }>
) => connect<TExtraProps, TFormValues>(WrappedComponent);

export default withFormWrapper;